import { render, staticRenderFns } from "./TableScore.vue?vue&type=template&id=230bf306&scoped=true"
import script from "./TableScore.vue?vue&type=script&lang=js"
export * from "./TableScore.vue?vue&type=script&lang=js"
import style0 from "./TableScore.vue?vue&type=style&index=0&id=230bf306&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230bf306",
  null
  
)

export default component.exports